import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { WheelsDetailComponent } from './wheels/wheels-detail/wheels-detail.component';
import { WheelsListingComponent } from './wheels/wheels-listing/wheels-listing.component';
import { ShoppingCartComponent } from '../cart/shopping-cart/shopping-cart.component';
import { AlloyWheelsComponent } from './alloy-wheels/alloy-wheels.component';
import { ProcessOrderComponent } from './process-order/process-order.component';
import { LoginComponent } from './login/login.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { CancelOrderComponent } from './cancel-order/cancel-order.component';
import { InstallmentsComponent } from './installments/installments.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FooterPagesComponent } from './footer-pages/footer-pages.component';
import { SearchComponent } from './search/search.component';
import { ClearnceWheelsComponent } from './clearnce-wheels/clearnce-wheels.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { MyVendorsComponent } from './my-vendors/my-vendors.component';
import { VendorLoginComponent } from './vendor-login/vendor-login.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { Page404Component } from './page404/page404.component';
import { BrandComponent } from './brand/brand.component';

import { SuppliersComponent } from './suppliers/suppliers.component';

import { NewHomeComponent } from './new-home/new-home.component';
import { FeatureComponent } from './feature/feature.component';
import { AccessoriesComponent } from './accessories/accessories.component';
import { AccessoriesDetailsComponent } from './accessories-details/accessories-details.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TutorialsComponent } from './tutorials/tutorials.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { NewProductsComponent } from './new-products/new-products.component';
const routes: Routes = [
  {
    path: '',
    component: FeatureComponent,
    data: {
      title:
        'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
      breadcrumbs: {
        title:
          'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
        description:
          'View Over 3000+ custom wheels to add to your cart and order online in UAE, Saudi Arabia, Oman, Bahrain and  Kuwait. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
      },
    },

    // component: LoginComponent,
    // data: {
    //   title: 'Login | Clockwork.app',
    //   breadcrumbs: {
    //     title: 'Login | Clockwork.app',
    //     description: 'Login to Clockwork.app and explore bespoke collection on Alloy wheels to order online.'
    //   }
    // }
    // data: {
    //   title: 'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
    //   breadcrumbs: {
    //     title: 'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
    //     description: 'View Over 3000+ custom wheels to add to your cart and order online in UAE, Saudi Arabia, Oman, Bahrain and  Kuwait. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.'
    //   }
    // },
  },
  {
    path: 'feature',
    component: NewHomeComponent,
    data: {
      title:
        'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
      breadcrumbs: {
        title:
          'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
        description:
          'View Over 3000+ custom wheels to add to your cart and order online in UAE, Saudi Arabia, Oman, Bahrain and  Kuwait. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
      },
    },
  },

  // {
  //   path: '',
  //   component: HomeComponent,
  //   data: {
  //     title:
  //       'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
  //     breadcrumbs: {
  //       title:
  //         'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
  //       description:
  //         'View Over 3000+ custom wheels to add to your cart and order online in UAE, Saudi Arabia, Oman, Bahrain and  Kuwait. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
  //     },
  //   },
  // },
  // {
  //   path: 'product/:id/:variant_id',
  //   component: WheelsDetailComponent,
  //   data: {
  //     title: 'Wheels Detail'
  //   }
  // },
  {
    path: 'serchvehicle',
    component: WheelsListingComponent,
    data: {
      title:
        'Order Mamba, Sparco, Raceline, Ridler wheels Online in Dubai, UAE | Free Delivery | Clockwork.app',
      breadcrumbs: {
        title:
          'Order Mamba, Sparco, Raceline, Ridler wheels Online in Dubai, UAE | Free Delivery | Clockwork.app',
        description:
          'Order Online high-Quality wheels from reputed brands like Mamba, Sparco, Raceline, Ridler in Dubai & across the Middle East. We have a wide range of wheels listed with fitment guarantee & free delivery in UAE.',
      },
    },
  },
  {
    path: 'wheelbrand/:brand/:product',
    component: BrandComponent,
    data: {
      title: 'Order __BRAND__ Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Qatar | ClockWork.app',
      breadcrumbs: {
        title: 'Order __BRAND__ Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Qatar | ClockWork.app',
        description: 'Authorized dealer for __BRAND__ Wheels in Dubai, Sharjah, Abu Dhabi & UAE - Order original __BRAND__ alloy wheels & rims online in UAE, Saudi Arabia, Oman, Bahrain and Kuwait. Free delivery in UAE.'
      }
    }
  },

  {
    path: 'wheelbrand/:brand',
    component: BrandComponent,
    data: {
      title:
        'Order __BRAND__ Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Qatar | ClockWork.app',
      breadcrumbs: {
        title:
          'Order __BRAND__ Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Qatar | ClockWork.app',
        description:
          'Authorized dealer for __BRAND__ Wheels in Dubai, Sharjah, Abu Dhabi & UAE - Order original __BRAND__ alloy wheels & rims online in UAE, Saudi Arabia, Oman, Bahrain and Kuwait. Free delivery in UAE.',
      },
    },
  },
  {
    path: 'wheelbrand',
    component: BrandComponent,
    data: {
      title: 'Order __BRAND__ Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Qatar | ClockWork.app',
      breadcrumbs: {
        title: 'Order __BRAND__ Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Qatar | ClockWork.app',
        description: 'Authorized dealer for __BRAND__ Wheels in Dubai, Sharjah, Abu Dhabi & UAE - Order original __BRAND__ alloy wheels & rims online in UAE, Saudi Arabia, Oman, Bahrain and Kuwait. Free delivery in UAE.'
      }
    }
  },
  {
    path: 'pre-order-deals',
    component: AlloyWheelsComponent,
    data: {
      title: 'Pre Order Deals | Free Delivery in UAE | ClockWork.app',
      breadcrumbs: {
        title: 'Pre Order Deals | Free Delivery in UAE | ClockWork.app',
        description: 'List of clearance wheels to order online in UAE, Saudi Arabia, Oman, Bahrain and Kuwait. Fitment gurantee and 100% original wheels with manufacturer warranty. Select among 70+ Brands of wheels.'
      }
    }
  },

  // {
  //   path: 'clearance-wheels',
  //   component: ClearnceWheelsComponent,
  //   data: {
  //     title: 'Clearance Wheels on Sale | Free Delivery in UAE | Clockwork.app',
  //     breadcrumbs: {
  //       title: 'Clearance Wheels on Sale | Free Delivery in UAE | Clockwork.app',
  //       description:
  //         'List of clearance wheels to order online in UAE, Saudi Arabia, Oman, Bahrain and Kuwait. Fitment gurantee and 100% original wheels with manufacturer warranty. Select among 70+ Brands of wheels.',
  //     },
  //   },
  // },
  {
    path: 'wheels',
    component: AlloyWheelsComponent,
    data: {
      title:
        'Order Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Clockwork.app',
      breadcrumbs: {
        title:
          'Order Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Clockwork.app',
        description:
          'Choose from over 3000+ custom Alloy wheels to order online in UAE, Saudi Arabia, Oman, Bahrain and Kuwait. Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty. Best prices and selection among 70+ top brands.',
      },
    },
  },
  {
    path: 'search-by-size',
    component: WheelsListingComponent,
    data: {
      title: 'Order Aftermarket Alloy Wheels Online in UAE | Clockwork.app',
      breadcrumbs: {
        title: 'Order Aftermarket Alloy Wheels Online in UAE | Clockwork.app',
        description:
          'Over 3000+ custom wheels to add to your cart and order online in UAE, Oman, Bahrain, Kuwait and Saudi Arabia. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
      },
    },
  },
  // {
  //   path: 'serchvehiclehome',
  //   component: WheelsListingComponent,
  //   data: {
  //     title: 'Order Aftermarket Alloy Wheels Online in UAE | Clockwork.app',
  //     breadcrumbs: {
  //       title: 'Order Aftermarket Alloy Wheels Online in UAE | Clockwork.app',
  //       description:
  //         'Over 3000+ custom wheels to add to your cart and order online in UAE, Oman, Bahrain, Kuwait and Saudi Arabia. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
  //     },
  //   },
  // },
  {
    path: 'cart',
    component: ShoppingCartComponent,
    data: {
      title: 'Shopping Cart',
    },
  },
  {
    path: 'process-payment',
    component: ProcessOrderComponent,
    data: {
      title: 'Process Request',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login | Clockwork.app',
      breadcrumbs: {
        title: 'Login | Clockwork.app',
        description:
          'Login to Clockwork.app and explore bespoke collection on Alloy wheels to order online.',
      },
    },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password',
      breadcrumbs: {
        title: 'Reset Password',
      },
    },
  },

  {
    path: 'vendor-login',
    component: VendorLoginComponent,
    data: {
      title: 'Vendor Login | Clockwork.app',
      breadcrumbs: {
        title: 'Vendor Login | Clockwork.app',
        description: '',
      },
    },
  },

  {
    path: 'thank-you',
    component: ThankYouComponent,
    data: {
      title: 'Thank you',
    },
  },
  {
    path: 'cancel-order',
    component: CancelOrderComponent,
    data: {
      title: 'Cancel Order',
    },
  },
  {
    path: 'installments',
    component: InstallmentsComponent,
    data: {
      title: 'Pay Installments & Installment Guide | Clockwork.app',
      breadcrumbs: {
        title: 'Pay Installments & Installment Guide | Clockwork.app',
        description:
          'Please find below the Clockwork.app Pay Installments & Installment Guide.',
      },
    },
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy | Clockwork.app',
    },
  },
  {
    path: 'about-us',
    component: FooterPagesComponent,
    data: {
      title:
        'Largest Online Retailer for Custom Wheels & tires in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Clockwork.app',
      url: 'about-us',
      description:
        'Clockwork.app sells a wide range of Alloy wheels, Custom wheels and tires from 70+ brands. Based in Dubai, UAE, With over 1000 trusted customers.',
    },
  },
  {
    path: 'terms-conditions',
    component: FooterPagesComponent,
    data: {
      title: 'Terms & Conditions | Clockwork.app',
      url: 'terms-conditions',
    },
  },
  {
    path: 'delivery-policy',
    component: FooterPagesComponent,
    data: {
      title: 'Delivery Policy | Clockwork.app',
      url: 'delivery-policy',
    },
  },
  {
    path: 'return-policy',
    component: FooterPagesComponent,
    data: {
      title: 'Return Policy | Clockwork.app',
      url: 'return-policy',
    },
  },
  {
    path: 'search',
    component: SearchComponent,
    data: {
      title: 'Search',
    },
  },
  {
    path: 'profile-dashboard',
    component: DashboardComponent,
    data: {
      title: 'dashboard',
    },
  },
  {
    path: 'new-products',
    component: NewProductsComponent,
    data: {
      title: 'Products',
    },
  },
  
  



  // {
  //   path: 'my-vendors',
  //   component: MyVendorsComponent,
  //   data: {
  //     title: 'My Vendors',
  //   },
  // },
  {
    path: 'suppliers',
    component: SuppliersComponent,
    data: {
      title: 'My Suppliers',
    },
  },

  {
    path: 'supplier/:id',
    component: SuppliersComponent,
    data: {
      title: 'Supplier',
    },
  },
  // {
  //   path: 'supplier/:id/:tab',
  //   component: SuppliersComponent,
  //   data: {
  //     title: 'Supplier',
  //   },
  // },
  // {
  //   path: 'supplier/:id/:product',
  //   component: SuppliersComponent,
  //   data: {
  //     title: 'Supplier Products',
  //   },
  // },

  {
    // Product URL SEO friendly
    path: ':id/:variant_id',
    component: WheelsDetailComponent,
    data: {
      title: 'Wheels Detail',
    },
  },

  {
    // Product URL SEO friendly
    path: 'landing-page',
    component: LandingPageComponent,
    data: {
      title: 'Landing Page',
    },
  },

  {
    // Product URL SEO friendly
    path: 'downloads',
    component: DownloadsComponent,
    data: {
      title: 'Downloads',
    },
  },
  {
    // Product URL SEO friendly
    path: 'accessories',
    component: AccessoriesComponent,
    data: {
      title: 'Accessories',
    },
  },
  {
    // Product URL SEO friendly
    path: 'accessories-details/:category/:sku/:id',
    component: AccessoriesDetailsComponent,
    data: {
      title: 'Accessories Details',
    },
  },
  
  {
    // Product URL SEO friendly
    path: 'tutorials',
    component: TutorialsComponent,
    data: {
      title: 'Tutorials',
    },
  },
  {
    // Product URL SEO friendly
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      title: 'Contact Us',
    },
  },
  {
    // Product URL SEO friendly
    path: '404',
    component: Page404Component,
    data: {
      title: '404',
    },
  },
  // {
  //   path: 'new-home',
  //   component: HomeComponent,
  //   data: {
  //     title:
  //       'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
  //     breadcrumbs: {
  //       title:
  //         'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
  //       description:
  //         'View Over 3000+ custom wheels to add to your cart and order online in UAE, Saudi Arabia, Oman, Bahrain and  Kuwait. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
  //     },
  //   },
  // },

  // {
  //   path: 'home-two',
  //   component: NewHomeComponent,
  //   data: {
  //     title:
  //       'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
  //     breadcrumbs: {
  //       title:
  //         'Buy Alloy Wheels Online in Dubai, Saudi Arabia, Oman, Kuwait, and Bahrain | Free Delivery in UAE | Clockwork.app',
  //       description:
  //         'View Over 3000+ custom wheels to add to your cart and order online in UAE, Saudi Arabia, Oman, Bahrain and  Kuwait. Best prices and selection, 70+ top brands, Free delivery in UAE, Fitment guarantee and 100% original wheels with manufacturer warranty.',
  //     },
  //   },
  // },






];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
